// Generic API-response shape helpers (shared by hooks + pages).

/**
 * Extracts the list of items from an API response. The lawyer-API
 * conventionally returns `{ pagination, results }` for paginated lists, but
 * a few endpoints return a bare array or `{ items }` / `{ data }`. This
 * helper handles all four shapes so each route adapter doesn't repeat the
 * same defensive code.
 */
export function extractList(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  return (
    payload.results ?? payload.items ?? payload.data ?? payload.members ?? []
  );
}

/**
 * Pulls a totals/count out of a paginated response when present, else
 * falls back to the list length.
 */
export function extractTotal(payload, list) {
  if (!payload || typeof payload !== 'object') return list.length;
  const fromPagination = payload.pagination?.totalRecords;
  if (fromPagination != null) return Number(fromPagination);
  return payload.total ?? payload.totalCount ?? list.length;
}
